<template>
  <div id="leftNavContainer" :style="{ width: leftW ? leftW : '230px' }">
    <transition name="fade">
      <el-tree :key="key" ref="tree" :props="defaultProps" :accordion="false" :default-expanded-keys="unfoldIdArr"
        :render-content="renderContent" :load="loadNode" highlight-current node-key="folderId" lazy
        @node-expand="treeExpand" @node-collapse="treeCollapse" @node-click="clickNodeTree">
      </el-tree>
    </transition>
  </div>
</template>

<script>
import docService from "@/CommonDP/service/doc-service";
import request from "@/CommonDP/utils/request";
import globalParams from "@/CommonDP/utils/globalParams";
import { isDef } from "@/CommonDP/utils/common";
import { mapState } from "vuex";
import { treeNodeIcon, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";

export default {
  props: {
    // 初始时定位显示的文件夹
    folderChain: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      argument: {
        folderId: 0,
        prjId: "",
        isRead: 1,
        priviAll: "1",
        noRightClickMenu: true,
        versionId: ""
      },
      defaultProps: {
        children: "children",
        label: "folderName",
        isLeaf: "leaf"
      },
      unfoldIdArr: [],
      isFirstLoading: true,
      isLoad: false,
      isrecycle: false,
      key: 1
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      openFolder: state => state.XtDesign.openFolder,
      delFolderID: state => state.XtDesign.delFolderID,
      nodeListKey: state => state.XtDesign.updateNodeListKey,
      listOnlyKey: state => state.docSort.updateListOnlyKey,
      currentNode: state => state.XtDesign.currentTreeNode,
      refreshKey: state => state.XtDesign.refreshKey,
      refreshFolderID: state => state.XtDesign.refreshFolderID,
      returnKey: state => state.XtDesign.returnKey,
      navArr: state => state.XtDesign.navArr,
      leftW: state => state.XtDesign.leftW,
      list: state => state.XtDesign.listArr,
      selectArr: state => state.XtDesign.selectArr,
      searchRow: state => state.XtDesign.searchRow,
      searchStatus: state => state.XtDesign.searchStatus,
      XtDesignTimerKey: state => state.XtDesign.timerKey,
      XtDesignTimerID: state => state.XtDesign.timerID,
      sortObj: state => state.XtDesign.sortDataObj,
      navIdArr: state => state.XtDesign.navIdArr,
      notUpdateSelect: state => state.XtDesign.notUpdateSelect
    })
  },

  watch: {
    openFolder: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (newValue.folderId) {
          // 点击表格里的文件夹
          this.treeFolderExpand(newValue);
        }
      }
    },
    // 返回上一级
    returnKey(newValue, oldValue) {
      if (newValue) {
        const { folderId } = this.navArr[this.navArr.length - 2];
        this.treeFolderExpand(folderId);
      }
    },

    delFolderID(newValue, oldValue) {
      newValue.forEach(item => {
        const node = this.$refs.tree.getNode(item);
        if (node) {
          this.$refs.tree.remove(node);
        }
      });
    },
    // 仅刷新右侧列表，不刷新左侧树
    listOnlyKey(newValue, oldValue) {
      if (newValue) {
        this.refreshListOnly();
      }
    },
    // 刷新
    nodeListKey(newValue, oldValue) {
      let { data } = this.currentNode;
      data = data || {};
      const { folderId } = data;
      if (folderId) {
        this.loadNode(this.currentNode);
      }
    },

    refreshKey(newValue, oldValue) {
      console.log("上传成功啦");
      const { data } = this.currentNode;
      if (newValue && this.refreshFolderID === data.folderId) {
        const node = this.$refs.tree.getNode(this.refreshFolderID);
        if (node) {
          this._RefreshPublic(this.refreshFolderID, node);
        }
      }
    },

    searchRow(newValue, oldValue) {
      if (newValue.folderId) {
        this.searchFolderExpand(newValue);
      }
    },

    XtDesignTimerKey(newValue, oldValue) {
      if (newValue) {
        const { data } = this.currentNode;
        this._autoRefresh(data.folderId, this.currentNode);
      }
    }
  },
  created() {
    this.argument.prjId = this.prjInfo.prjId;
  },
  mounted() {},
  methods: {
    queryTreeWithSort(data) {
      const sortTypeMap = { fileNameSort: 'name', checkInDate: 'time', fileSuffix: 'type', size: 'size' };
      const sortOrderMap = { ascending: 'asc', descending: 'desc' };
      const { prop, order } = this.sortObj || {};
      const sortType = sortTypeMap[prop] || 'name';
      const sortOrder = sortOrderMap[order] || 'asc';
      const newUrl = globalParams.get("url:/doc/list");
      const url = isDef(newUrl) ? newUrl : "/doc/list";
      return request.post(`${url}?sortType=${sortType}&sortOrder=${sortOrder}`, data).then(res => res);
    },

    async loadNode(node, resolve) {
      if (this.isLoad) return;
      this.isLoad = true;
      this.isrecycle = false;
      this.$store.dispatch("XtDesignUpdateSearchStatus", false);
      if (node.isExpand) {
        node.collapse();
      } else {
        node.expand();
      }
      if (this.notUpdateSelect) {
        this.$store.dispatch("XtDesignUpdateSelect", []);
      }
      if (node.level === 0) {
        try {
          if (this.argument.prjId) {
            const result = await this.queryTreeWithSort(this.argument);
            if (result.result === "0") {
              if (result.data[0]) {
                const navIdArr = this.navIdArr || [];
                // folderChain传参使用 - 分割 一定程度上约束传入具有前后关系的文件夹链
                if (this.folderChain) {
                  this.unfoldIdArr = this.folderChain.split("-");
                } else {
                  if (navIdArr.length) {
                    this.unfoldIdArr = navIdArr;
                  } else {
                    this.unfoldIdArr.push(result.data[0].folderId);
                    this.$store.dispatch("XtDesignUpdateNav", [result.data[0]]);
                  }
                }
              } else result.data = [];
              this.isLoad = false;
              const list = result.data.map(item => {
                const { childFolder = 0 } = item;
                return {
                  ...item,
                  leaf: childFolder === 0
                };
              });
              resolve(list);
              if (this.isrecycle) {
                for (var i = 0; i < result.data.length; i++) {
                  this.$set(result.data[i], "isrecycle", true);
                }
              } else {
                for (var a = 0; a < result.data.length; a++) {
                  this.$set(result.data[a], "isrecycle", false);
                }
              }
              this.$store.dispatch("XtDesignUpdateList", result.data);
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false
              });
            }
          }
        } catch (e) {
          this.$store.dispatch("XtDesignUpdateMessageObj", {
            isShow: true,
            message: e.message || "加载失败"
          });
        }
      } else {
        this.getChildren(node, resolve);
      }
    },

    async getChildren(node, resolve) {
      const { data } = node;
      const { folderId, parentId } = data;

      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey(folderId);
        }
      });

      this.creatNav(node);

      this.argument.folderId = folderId;
      this.$store.dispatch("XtDesignUpdateTreeNode", node);
      // 如果parentId等于0 就是顶级
      if (parentId === "0") {
        this.$store.dispatch("XtDesignUpdateTopTreeNode", node);
      }
      const requestType = this.requestType(data, node);
      try {
        const result = await requestType;
        if (result.result === "0") {
          const newData = this._isFolder(result.data);
          const list = newData.map(item => {
            const { childFolder = 0 } = item;
            return {
              ...item,
              leaf: childFolder === 0
            };
          });
          this.isLoad = false;
          if (resolve) {
            resolve(list);
          } else {
            node.childNodes = [];
            node.doCreateChildren(list);
          }
          if (this.isrecycle) {
            for (var i = 0; i < result.data.length; i++) {
              this.$set(result.data[i], "isrecycle", true);
            }
          } else {
            for (var b = 0; b < result.data.length; b++) {
              this.$set(result.data[b], "isrecycle", false);
            }
          }
          this.$store.dispatch("XtDesignUpdateList", result.data);

          if (this.isFirstLoading) {
            this.openTimer();
          }

          if (node.isExpand || this.isFirstLoading) {
            node.expand();
            this.isFirstLoading = false;
          } else {
            node.collapse();
          }

          node.loading = false;
        }
      } catch (e) {
        this.isLoad = false;
        this.$message.warning(e.message || "请求处理失败");
        node.loading = false;
      }
    },

    async refreshListOnly() {
      if (!this.argument.folderId) return;
      try {
        const result = await this.queryTreeWithSort(this.argument);
        if (result.result === '0') {
          this.$store.dispatch('XtDesignUpdateList', result.data);
        }
      } catch (e) {
        // 静默失败，不影响页面
      }
    },

    async requestType(data, node) {
      let Request;
      const { prjId } = this.prjInfo;
      if (data.folderId === "recycle") {
        this.isrecycle = true;
        Request = docService.queryRecycle(prjId, "");
      } else {
        this.isrecycle = false;
        Request = this.queryTreeWithSort(this.argument);
      }
      return Request;
    },

    openTimer() {
      clearInterval(this.XtDesignTimerID);
      const timerID = setInterval(() => {
        if (!this.searchStatus && this.findRvtDwgType()) {
          this.$store.dispatch("XtDesignSortData", this.sortObj);
          this.$store.dispatch("XtDesignUpdateTimerKey");
        }
      }, 15000);
      this.$store.dispatch("XtDesignUpdateTimerID", timerID);
    },

    findRvtDwgType() {
      return this.list.some(item => item && common2D3DFileType(item));
    },

    _isFolder(data) {
      return data.filter(item => item.isFolder === 1);
    },

    treeExpand(data, node) {
      node.isExpand = true;
      this.publicOpenFolder(data, node);
      const obj = { prop: "fileNameSort", order: "ascending" };
      this.$store.dispatch("XtDesignSortData", obj);
    },

    treeCollapse(data, node) {
      node.isExpand = false;
      this.publicOpenFolder(data, node);
    },

    async clickNodeTree(data, node) {
      this.publicOpenFolder(data, node);
      // 默认为名称升序
      const obj = { prop: "fileNameSort", order: "ascending" };
      this.$store.dispatch("XtDesignSortData", obj);
    },

    publicOpenFolder(data, node) {
      this.unfoldIdArr = [];
      this.loadNode(node);
    },

    treeFolderExpand(row) {
      const { folderId } = row;
      this.argument.folderId = folderId;
      const node = this.$refs.tree.getNode(row);

      node.isExpand = true;
      node.parent.expand();
      this.publicOpenFolder(row, node);
    },

    creatNav(node) {
      const arr = [node];
      while (arr[arr.length - 1] && arr[arr.length - 1].parent.data) {
        const lastNode = arr[arr.length - 1];
        arr.push(lastNode.parent);
      }
      const data = arr.map(item => item.data).reverse();
      this.$store.dispatch("XtDesignUpdateNav", data);
    },

    renderContent(h, { node, data, store }) {
      return h(
        "div",
        {
          style: "display:flex;align-items:center;width:100%;overflow: hidden;padding-right:25px"
        },
        [
          h("img", {
            attrs: {
              src: treeNodeIcon(node.data)
            },
            style: "margin-right:6px;-webkit-user-drag: none;-moz-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none;"
          }),
          h("div", {
            domProps: {
              innerText: node.label
            },
            attrs: {
              class: "ellipsis",
              title: node.label
            }
          })
        ]
      );
    },

    async _RefreshPublic(folderId, node) {
      node.loading = true;
      try {
        const requestType = this.requestType({ folderId }, node);
        const result = await requestType;
        if (result.result === "0") {
          this.$store.dispatch("XtDesignUpdateList", []);
          this.creatNav(node);
          setTimeout(() => {
            this.$refs.tree?.updateKeyChildren(folderId, this._isFolder(result.data));
            if (this.isrecycle) {
              for (var i = 0; i < result.data.length; i++) {
                this.$set(result.data[i], "isrecycle", true);
              }
            } else {
              for (var c = 0; c < result.data.length; c++) {
                this.$set(result.data[c], "isrecycle", false);
              }
            }
            this.$store.dispatch("XtDesignUpdateList", result.data);
            this.creatNav(node);
            node.loading = false;
          }, 100);
        }
      } catch (e) {
        node.loading = false;
        this.$message.warning(e.message || "请求处理失败");
      }
    },

    async _autoRefresh(folderId, node) {
      let oldSelectArr = this.selectArr;
      try {
        const requestType = this.requestType({ folderId }, node);
        const result = await requestType;
        if (result.result === "0") {
          if (!this.searchStatus && this.findRvtDwgType()) {
            this.creatNav(node);
            if (this.isrecycle) {
              for (var i = 0; i < result.data.length; i++) {
                this.$set(result.data[i], "isrecycle", true);
              }
            } else {
              for (var d = 0; d < result.data.length; d++) {
                this.$set(result.data[d], "isrecycle", false);
              }
            }
            this.$store.dispatch("XtDesignUpdateList", result.data);
            this.$nextTick(() => {
              this.$store.dispatch("XtDesignUpdateSelectKey", [...oldSelectArr]);
              oldSelectArr = null;
            });
          }
        }
      } catch (e) {
        this.$message.warning(e.message || "请求处理失败");
      }
    },

    async searchFolderExpand(row) {
      this.isrecycle = false;
      const { folderId } = row;
      const argument = { ...this.argument };
      argument.folderId = folderId;
      try {
        const result = await this.queryTreeWithSort(argument);
        if (result.result === "0") {
          if (this.isrecycle) {
            for (var i = 0; i < result.data.length; i++) {
              this.$set(result.data[i], "isrecycle", true);
            }
          } else {
            for (var e = 0; e < result.data.length; e++) {
              this.$set(result.data[e], "isrecycle", false);
            }
          }
          this.$store.dispatch("XtDesignUpdateList", result.data);
          if (!row.isSearch) {
            row.isSearch = true;
            await this.$store.dispatch("XtDesignUpdateNav", []);
            const res = await workProjectBoardService.getAssociatedFolderLocation(row.folderId);
            for (let i = 0; i < res.data.length; i++) {
              const ele = res.data[i];
              this.navArr.push(ele);
            }
            this.argument.folderId = 0;
            this.key++;
          } else {
            const length = this.navArr.length - 1;
            this.navArr.splice(length, 1);
          }
          this.$store.dispatch("XtDesignUpdateNav", this.navArr);
        }
      } catch (e) {
        // console.log('111')
        this.$message.warning(e.message || "请求处理失败");
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#leftNavContainer::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

#leftNavContainer::-webkit-scrollbar-track {
  background: rgb(255, 255, 255);
  border-radius: 2px;
}

#leftNavContainer::-webkit-scrollbar-thumb {
  background: #eee;
  border-radius: 10px;
}

#leftNavContainer::-webkit-scrollbar-thumb:hover {
  background: #C4C6CC;
}

#leftNavContainer {
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  padding: 10px 0 0 0px;
  box-sizing: border-box;
  border-radius: 4px;

  /deep/ .el-tree {
    width: 100%;

    .el-tree-node__children, .fade-enter-active, .fade-leave-active {
      transition: height 0.3s;
    }
  }
}
</style>
